export default __webpack_public_path__ + "static/media/325-3258657_good-morning-america-good-morning-america-logo 1.c19fadfd.svg";